<ng-template #loading>
   <mat-progress-bar id="templateProgressBar" mode="indeterminate"></mat-progress-bar>
</ng-template>

<ng-template #noresults>
   <div id="noTemplate" class="no-results">No Matching Templates</div>
</ng-template>

<ng-container *ngIf="_templates | async else loading">
   <div class="template-manage noselect">
      <div class="header flex">
         <lib-status-legend id="templateStatus" [selected]="shared_key" (clicked)="toggle_shared_key( $event )"></lib-status-legend>
         <button id="newTemplateButton" mat-raised-button color="primary" routerLink="/template/new">
            <mat-icon id="newTemplateIcon">add</mat-icon> NEW
         </button>
      </div>

      <ng-container *ngIf="dataSource.filteredData.length else noresults">
         <ng-container *ngIf="[ 'status', 'name', 'description', 'owner_name', 'last_updated', 'actions' ] as columns">
            <mat-table [dataSource]="dataSource" class="rotate-cdk-table" matSort>
               <ng-container matColumnDef="status">
                  <mat-header-cell id="statusHeader" *matHeaderCellDef class="common-fg05">Status</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="common-fg05">
                     <div class="header">Status</div>
                     <div class="cell">
                        <ng-container *ngIf="SharedKeysMap( row ) as status">
                           <button id="filterStatusButton" mat-button (click)="toggle_shared_key( status )" [style.left.px]=" !breakpoints.large ? -16 : null" matTooltip="Click to filter by this status">
                              <span class="status" [ngClass]="status"></span>
                              <span *ngIf="!breakpoints.large" class="common-ml2ex"> {{SharedKeysEnum[status]}}</span>
                           </button>
                        </ng-container>
                     </div>
                  </mat-cell>
               </ng-container>

               <ng-container matColumnDef="name">
                  <mat-header-cell id="nameHeader" *matHeaderCellDef mat-sort-header class="common-fg2">Name</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="common-fg2">
                     <div class="header">Name</div>
                     <div id="templateName" class="cell">
                        <ng-container *ngIf="!row.owned else link">{{row.name}}</ng-container>
                        <ng-template #link>
                           <a routerLink="/template/edit/{{row.id}}" class="common-tdnone">{{row.name}}</a>
                        </ng-template>
                     </div>
                  </mat-cell>
               </ng-container>

               
               <ng-container matColumnDef="description">
                  <mat-header-cell id="descriptionHeader" *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
                  <mat-cell [matTooltip]="row.description" *matCellDef="let row">
                     <div class="header">Description</div>
                     <div id="templateDescription" class="description-cell">{{row.description}}</div>
                  </mat-cell>
               </ng-container>


               <ng-container matColumnDef="owner_name">
                  <mat-header-cell id="ownerHeader" *matHeaderCellDef mat-sort-header>Owner</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                     <div class="header">Owner</div>
                     <div class="cell">
                        <a id="templateOwner" class="common-tdnone common-pointer" (click)="dataSource.filter = ( dataSource.filter == row.owner_name ) ? '' : row.owner_name">{{row.owner_name}}</a>
                     </div>
                  </mat-cell>
               </ng-container>

               <ng-container matColumnDef="last_updated">
                  <mat-header-cell id="lastUpdatedHeader" *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
                  <mat-cell *matCellDef="let row">
                     <div class="header">Last updated</div>
                     <div id="templateLastUpdated" class="cell">{{row.last_updated | date}}</div>
                  </mat-cell>
               </ng-container>

               <ng-container matColumnDef="actions">
                  <mat-header-cell id="actionsHeader" *matHeaderCellDef class="common-fg15">Actions</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="common-fg15 common-pr0 common-wsnw">
                     <div class="header">Actions</div>
                     <div class="cell" *ngIf="!_deleting">
                        
                        <button id="actionsButton" mat-icon-button color="primary" [loading]="_creating === row.id" [matMenuTriggerFor]="actions">
                           <mat-icon id="actionsIcon">more_vert</mat-icon>
                        </button>

                        <mat-menu #actions="matMenu" class="float-menu" xPosition="before" yPosition="below" overlapTrigger="false">
                           <button id="createShipmentButton" mat-menu-item *ngIf="isShipment" (click)="createShipment( row.id )">
                              <mat-icon id="createShipmentIcon" svgIcon="createshipment"></mat-icon>
                              Create Shipment
                           </button>
                           <button id="createQuoteButton" mat-menu-item *ngIf="isQuoting" (click)="createQuotation( row.id )">
                              <mat-icon id="createQuoteIcon">request_quote</mat-icon>
                              Create Quote
                           </button>
                           <button id="editButton" mat-menu-item routerLink="/template/edit/{{row.id}}" *ngIf="row.owned">
                              <mat-icon id="editIcon">edit</mat-icon> Edit
                           </button>
                           <button id="exportButton" mat-menu-item *ngIf="false">
                              <mat-icon id="exportIcon">get_app</mat-icon> Export
                           </button>
                           <button id="deleteButton" mat-menu-item (click)="deleting = row" *ngIf="row.owned">
                              <mat-icon id="deleteIcon">delete</mat-icon> Delete
                           </button>
                        </mat-menu>
                     </div>
                  </mat-cell>
               </ng-container>

               <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
               <mat-row *matRowDef="let row; columns: columns"></mat-row>
            </mat-table>
         </ng-container>
      </ng-container>

      <div #deleteConfirm class="delete-confirm" *ngIf="_deleting">
         <div id="deleteWarning" color="warn" class="common-mb1em" *ngIf="_deleting.shared">
            Warning! This template is shared and other users will lose access to it!
         </div>
         <div class="delete-confirm-actions">
            <div id="deleteConfirmation" class="common-mr1em">Are you sure you want to delete this template?</div>
            <button id="confirmDeleteButton" mat-raised-button color="warn" (click)="delete( _deleting )">Delete</button>
            <button id="cancelDeleteButton" mat-button (click)="deleting = null">Cancel</button>
         </div>
      </div>

      <mat-paginator id="templatePagination"
         [pageSize]="pageSize"
         [pageSizeOptions]="[5, 10, 25, 100]"
         (page)="pageSize = $event.pageSize">
      </mat-paginator>
   </div>
</ng-container>
